const routes = [
    {
        path: '/',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'listarNotasFiscaisCompras',
                path: '/notas_fiscais_compras',
                alias: '/notas_fiscais_compras/index',
                component: () => import('../views/Listar')
            },
            {
                name: 'ImportarXmlnotas_fiscais_compras',
                path: '/notas_fiscais_compras/importar_xml',
                component: () => import('../views/ImportarXml')
            }
        ]
    },
    {
        name: 'imprimirDanfeCompra',
        path: '/notas_fiscais_compras/imprimir_danfe/:id',
        component: () => import('@/shared/components/ui/Impressao'),
    },
]

export default routes
